var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_278)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#27709A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.39 0.000170827L1920 0.00012207L1920 342L1175 1082L-6 1082L1081.39 0.000170827Z",
    fill: "url(#paint0_linear_289_278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1080L1171 1080L1920 335L1920 1080Z",
    fill: "url(#paint1_linear_289_278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.644 539.644L-0.229429 1079.52L8.73394e-05 8.73394e-05L539.644 539.644Z",
    fill: "url(#paint2_linear_289_278)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_278",
    x1: 957,
    y1: 1082,
    x2: 1992,
    y2: 57.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_278",
    x1: 1805,
    y1: 933,
    x2: 1207,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0350815,
    stopColor: "#1A4163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_289_278",
    x1: 269.707,
    y1: 809.581,
    x2: -188.937,
    y2: 350.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#32BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3185FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.edda2437bfd5f96654d493588a83e7d7.svg";
export { ForwardRef as ReactComponent };